<template>
    <CardPage :section="1" :page="9" next="/" nextLabel="Finish" :nextFunction="finish" :audio="true">
        <p>
            Well, look at that! You’ve earned your first sticker! It’s our house logo. Keep going to earn more!
        </p>
        <ResponsiveImage :src="sticker.image" :alt="sticker.text"></ResponsiveImage>
    </CardPage>
</template>

<script>
import { get } from 'vuex-pathify';

export default {
    computed: {
        sticker: get('section1/sticker')
    },
    methods: {
        finish() {
            this.$store.set('section1/complete', true);
            this.$store.set('section1/sticker@earned', true);
        }
    }
};
</script>
